import { render, staticRenderFns } from "./TemplatePicSelector.vue?vue&type=template&id=715e45b8&scoped=true&"
import script from "./TemplatePicSelector.vue?vue&type=script&lang=js&"
export * from "./TemplatePicSelector.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePicSelector.vue?vue&type=style&index=0&id=715e45b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715e45b8",
  null
  
)

export default component.exports